import generalUpload from "../_section/upload.class";

export class userIdentificationUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Expiry Date',
            type: 'date',
        }, {
            name: 'dob',
            label: 'Date of Birth',
            type: 'date',
        }, {
            name: 'fullName',
            label: 'Full Name',
            type: 'text',
        }
    ]
}
export class adminIdentificationUpload extends userIdentificationUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.stampRequired = true; // must happen before values calced, as upload-steps depend on it
        this.calcValues(template)

        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.subtract(1.1, 'month'),
            })
        }
    }
}
